import { Trans } from '@lingui/react'
import { type Dispatch, type ReactElement, type SetStateAction } from 'react'

import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import { type PageType } from 'types/cmsTypes'
import { type Tenant } from 'types/shopConfig'
import IconNowPin from 'views/components/atoms/Icon/IconNowPin'
import NowZipModalBlueVariant from 'views/components/organisms/NowZipModalBlueVariant'
import { nowGlobalBarClickEvent } from 'views/utils/nowGlobalBar'
import './NowGlobalBarContentBlueVariant.scss'

interface INowGlobalBarContentBlueVariantProps {
  zip: string
  city: string
  setOpenNowZipModal: Dispatch<SetStateAction<boolean>>
  openNowZipModal: boolean
  pageType: PageType
  tenant: Tenant
}

const NowGlobalBarContentBlueVariant: (
  props: INowGlobalBarContentBlueVariantProps
) => ReactElement = ({
  zip,
  city,
  setOpenNowZipModal,
  openNowZipModal,
  pageType,
  tenant,
}) => {
  const displayUsersData = () => {
    let displayString = ''

    if (zip) {
      displayString = zip

      if (city) {
        displayString += `, ${city}`
      }
    }

    return displayString
  }

  return (
    <>
      <div
        className="l-flex__full-width o-NowGlobalBarContentBlueVariant__content"
        role="button"
        tabIndex={0}
        onClick={() => {
          setOpenNowZipModal(true)
          trackOptimizelyEvent(nowGlobalBarClickEvent(pageType))
        }}
        onKeyDown={undefined}
      >
        <div className="l-content o-NowGlobalBarContentBlueVariant__container">
          {zip ? (
            <>
              <IconNowPin className="o-NowGlobalBarContentBlueVariant__pinIcon o-NowGlobalBarContentBlueVariant__iconWithZip" />
              <span className="o-NowGlobalBarContentBlueVariant__text">
                <Trans id="general.label.nowGlobalBar.shippingTo" />{' '}
                <strong>{displayUsersData()}</strong>
              </span>
            </>
          ) : (
            <>
              <IconNowPin className="o-NowGlobalBarContentBlueVariant__pinIcon" />
              <span className="o-NowGlobalBarContentBlueVariant__text">
                <span>
                  <Trans id="general.label.nowGlobalBar.enterZipCode" /> &{' '}
                </span>
                <strong>
                  <Trans id="general.label.nowGlobalBar.enterZipAndFasterShipping" />
                  !
                </strong>
              </span>
            </>
          )}
        </div>
      </div>
      <NowZipModalBlueVariant
        id="nowZipModal"
        open={openNowZipModal}
        setModalOpen={setOpenNowZipModal}
        zip={zip}
        pageType={pageType}
        tenant={tenant}
      />
    </>
  )
}

export default NowGlobalBarContentBlueVariant
